/**
 * Performance HUD Manager
 * Directly handles DOM updates for real-time counters (Elapsed Time, Ball Count, Bounce Count, etc.)
 * to bypass React re-render cycles and maintain 60/144 FPS.
 */

export const updatePerformanceHUD = (
  elapsedTime: number,
  bounceCount: number,
  ballCount: number,
  ringsLeft: number,
  timeRemaining: number,
  currentRound: number,
  containerRadius: number,
  rhythmicEscapeShieldRingRadius: number,
  mode: string,
  fps: number
) => {
  if (typeof document === 'undefined') return;

  // 1. Elapsed Time Update (Render format matching SimulationHUD: s.ss)
  const elapsedEl = document.getElementById('hud-val-elapsed');
  if (elapsedEl) {
    elapsedEl.textContent = `${(elapsedTime / 1000).toFixed(2)}s`;
  }

  // 2. Spheres (Ball count)
  const spheresEl = document.getElementById('hud-val-spheres');
  if (spheresEl) {
    spheresEl.textContent = String(ballCount);
  }

  // 3. Bounces (bounce count)
  const bouncesEl = document.getElementById('hud-val-bounces');
  if (bouncesEl) {
    bouncesEl.textContent = String(bounceCount);
  }

  // 4. Rings left
  const ringsEl = document.getElementById('hud-val-rings');
  if (ringsEl) {
    ringsEl.textContent = String(ringsLeft);
  }

  // 5. Time Remaining (Challenge modes)
  const timeEl = document.getElementById('hud-val-time');
  if (timeEl) {
    timeEl.textContent = `${timeRemaining.toFixed(1)}s`;
  }

  // 6. Round Number (Space Spiral mode)
  const roundEl = document.getElementById('hud-val-round');
  if (roundEl) {
    roundEl.textContent = String(currentRound);
  }

  // 7. Dynamic Boundary Radius
  const radiusEl = document.getElementById('hud-val-radius');
  if (radiusEl) {
    const radiusVal = mode === 'RHYTHMIC_ESCAPE' ? rhythmicEscapeShieldRingRadius : containerRadius;
    radiusEl.textContent = `${radiusVal.toFixed(0)}px`;
  }

  // 8. Low-overhead Frame Rate Indicator
  const fpsEl = document.getElementById('hud-val-fps');
  if (fpsEl) {
    fpsEl.textContent = String(fps);
  }

  // 9. Traditional Header Badge
  const headerStatusTextEl = document.getElementById('header-status-text');
  if (headerStatusTextEl) {
     headerStatusTextEl.textContent = mode === 'ESCAPE' ? `${ringsLeft} Rings Left` : `${bounceCount} Bounces`;
  }
};
